import { CloseCircleOutlined } from "@ant-design/icons";
import { Checkbox, Col, Input, Row, Select, Spin, message } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { apiSaveRegistrationGeneral, apiGetWebpageGroups } from "services/dashboardService";
import { apiGetClubSite } from "services/customWebpageService";
import { ValidateEmail, isEmpty } from "utils/GlobalFunctions";
const GeneralTab = (props) => {
  const { Option } = Select;
  const { activityList, registrationID, setRegistrationID, settingInfo } =
    props;
  const userDataStore = useSelector((x) => x.userDataStore);
  const appDataStore = useSelector((x) => x.appDataStore);

  const [userData, setUserData] = useState({
  });
  const [errorField, setErrorField] = useState([]);
  const [isBusy, setIsBusy] = useState(false);
  const [selInfoFile, setSelInfoFile] = useState("");
  const [infoUrl, setInfoUrl] = useState("");
  const [currentInfoUrl, setCurrentInfoUrl] = useState("");
  const [webpageGroups, setWebpageGroups] = useState([]);
  const [clubSiteDomain, setClubSiteDomain] = useState("");

  useEffect(() => {
    // Load webpage groups and club site domain
    const clubID = appDataStore?.club?.id;
    if (clubID && userDataStore.token) {
      const params = new URLSearchParams();
      params.append("token", userDataStore.token);
      params.append("club_id", clubID);
      apiGetWebpageGroups(params)
        .then((res) => {
          if (res && Array.isArray(res)) {
            setWebpageGroups(res);
          }
        })
        .catch((err) => {
          console.error("Failed to load webpage groups:", err);
        });

      // Fetch club site domain
      apiGetClubSite({ token: userDataStore.token, club_id: clubID })
        .then((res) => {
          if (res && res.domain) {
            setClubSiteDomain(res.domain);
          }
        })
        .catch((err) => {
          console.error("Failed to load club site:", err);
        });
    }
  }, [appDataStore?.club?.id, userDataStore.token]);

  useEffect(() => {
    if (settingInfo != undefined && settingInfo.registration_info) {
      let tmpActivity = "";
      let tmpSport_id = "";
      let tmpSport = "";
      if (activityList.length > 0) {
        let tmpList = [...activityList];
        let selActivity = tmpList.filter(
          (z) =>
            z.NAME == settingInfo.registration_info.club_sport &&
            z.TYPE == settingInfo.registration_info.club_sport_id
        )[0];

        if (selActivity != undefined) {
          tmpActivity = parseInt(selActivity.ID);
          tmpSport_id = selActivity.TYPE;
          tmpSport = selActivity.NAME;
        }
      }

      let tmpInfoUrl = "";
      if (settingInfo.registration_info.homepage_info) {
        tmpInfoUrl = settingInfo.registration_info.homepage_info.split("uploads/home_info/")[1];
      }
      setCurrentInfoUrl(tmpInfoUrl);
      // Reset userData completely - don't spread old state to avoid cross-registration data
      setUserData({
        name: settingInfo.registration_info.registration_name,
        registration_description: (settingInfo.registration_info.registration_description || "").replace(/\\n/g, "\n"),
        registration_type: settingInfo.registration_info.registration_type || "individual",
        no_registration_required: settingInfo.registration_info.no_registration_required === 1 || settingInfo.registration_info.no_registration_required === "1",
        allow_multiple_participants: settingInfo.registration_info.allow_multiple_participants !== 0 && settingInfo.registration_info.allow_multiple_participants !== "0",
        allow_multi_select_registrations: settingInfo.registration_info.allow_multi_select_registrations !== 0 && settingInfo.registration_info.allow_multi_select_registrations !== "0",
        merchant: settingInfo.registration_info.merchant,
        credit_fee: settingInfo.registration_info.credit_fee,
        debit_fee: settingInfo.registration_info.debit_fee,
        echeck_fee: settingInfo.registration_info.echeck_fee,
        admin_email: settingInfo.registration_info.admin_email,
        webpage_group: settingInfo.registration_info.webpage_group || "",
        activity: tmpActivity,
        sport_id: tmpSport_id,
        sport: tmpSport,
      });
      // Clear any file selection when switching registrations
      setSelInfoFile("");
      setInfoUrl("");
    }
  }, [settingInfo, activityList, registrationID]);

  const validateFields = () => {
    let errorList = Array();
    errorList = isEmpty(userData, "name", errorList);
    errorList = isEmpty(userData, "activity", errorList);
    errorList = isEmpty(userData, "admin_email", errorList);
    if (!errorList.includes("admin_email")) {
      if (!ValidateEmail(userData.admin_email)) {
        errorList = [...errorList, "admin_email"]
      }
    }
    errorList = isEmpty(userData, "merchant", errorList);
    errorList = isEmpty(userData, "credit_fee", errorList);
    errorList = isEmpty(userData, "debit_fee", errorList);
    errorList = isEmpty(userData, "echeck_fee", errorList);
    setErrorField([...errorList]);
    return errorList.length == 0;
  };
  const onSave = () => {
    if (!validateFields()) return;

    let clubID = appDataStore?.club?.id;
    // Use FormData instead of URLSearchParams to support file uploads
    const params = new FormData();
    params.append("token", userDataStore.token);
    params.append("registration_id", registrationID);
    params.append("club_id", clubID);
    params.append("sport_id", userData.sport_id);
    params.append("sport", userData.sport);
    params.append("name", userData.name);
    params.append("registration_description", (userData.registration_description || "").replace(/\n/g, "\\n"));
    params.append("registration_type", userData.registration_type || "individual");
    params.append("no_registration_required", userData.no_registration_required ? "1" : "0");
    params.append("allow_multiple_participants", userData.allow_multiple_participants ? "1" : "0");
    params.append("allow_multi_select_registrations", userData.allow_multi_select_registrations ? "1" : "0");
    params.append("merchant", userData.merchant);
    params.append("credit_fee", userData.credit_fee);
    params.append("debit_fee", userData.debit_fee);
    params.append("echeck_fee", userData.echeck_fee);
    params.append("admin_email", userData.admin_email);
    params.append("webpage_group", userData.webpage_group || "");
    // Use domain from registration if exists, otherwise from club site
    const domainToSave = settingInfo?.registration_info?.domain || clubSiteDomain;
    if (domainToSave) {
      params.append("domain", domainToSave);
    }
    if (selInfoFile !== "") {
      params.append("home_info", selInfoFile);
    }
    setIsBusy(true);
    apiSaveRegistrationGeneral(params)
      .then((res) => {
        setIsBusy(false);
        if (res != undefined && res.registration_id != undefined) {
          setRegistrationID(res.registration_id);
          message.success("Registration information saved successfully.");
        } else {
          message.error(res?.msg);
        }
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  return (
    <div>
      <Spin spinning={isBusy}>
        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
              Registration Name*
            </div>
            <Input
              value={userData.name}
              className={
                errorField !== undefined && errorField.includes("name")
                  ? `common-input-error`
                  : `common-input`
              }
              onChange={(e) => {
                if (errorField.includes("name")) {
                  let errors = errorField.filter((x) => x != "name");
                  setErrorField([...errors]);
                }
                setUserData({ ...userData, name: e.target.value });
              }}
            />
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
              Registration Description
            </div>
            <Input.TextArea
              value={userData.registration_description}
              rows={3}
              className="common-input"
              placeholder="Enter a description for this registration"
              onChange={(e) => {
                setUserData({ ...userData, registration_description: e.target.value });
              }}
            />
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
              Registration Type
            </div>
            <Select
              className="common-select"
              value={userData.registration_type || "individual"}
              onSelect={(v) => {
                setUserData({ ...userData, registration_type: v });
              }}
            >
              <Option value="individual">Individual Registration</Option>
              <Option value="facility">Facility Registration</Option>
            </Select>
            <div style={{ fontSize: "12px", color: "#888", marginTop: "5px" }}>
              Individual: People signing up for programs. Facility: Booking facilities/venues.
            </div>
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
              Activity Type*
            </div>
            <Select
              showSearch
              className={
                errorField !== undefined && errorField.includes("activity")
                  ? `common-select-error`
                  : `common-select`
              }
              value={userData.activity == undefined ? null : userData.activity}
              onSelect={(v, item) => {
                if (errorField.includes("activity")) {
                  let errors = errorField.filter((x) => x != "activity");
                  setErrorField([...errors]);
                }
                let tmpList = [...activityList];
                let selActivity = tmpList.filter((z) => z.ID == v)[0];
                setUserData({
                  ...userData,
                  sport_id: selActivity.TYPE,
                  sport: selActivity.NAME,
                  activity: v,
                });
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {activityList.map((x, index) => {
                return (
                  <Option value={parseInt(x.ID)} key={index}>
                    {x.NAME}
                  </Option>
                );
              })}
            </Select>
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
              Admin Email Address*
            </div>
            <Input
              value={userData.admin_email}
              className={
                errorField !== undefined && errorField.includes("admin_email")
                  ? `common-input-error`
                  : `common-input`
              }
              onChange={(e) => {
                if (errorField.includes("admin_email")) {
                  let errors = errorField.filter((x) => x != "admin_email");
                  setErrorField([...errors]);
                }
                setUserData({ ...userData, admin_email: e.target.value });
              }}
            />
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
              Merchant*
            </div>
            <Select
              showSearch
              className={
                errorField !== undefined && errorField.includes("merchant")
                  ? `common-select-error`
                  : `common-select`
              }
              value={userData.merchant == undefined ? null : userData.merchant}
              onSelect={(v) => {
                if (errorField.includes("merchant")) {
                  let errors = errorField.filter((x) => x != "merchant");
                  setErrorField([...errors]);
                }
                setUserData({ ...userData, merchant: v });
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value={"stax"}>Stax</Option>
              <Option value={"forte"}>Forte</Option>
            </Select>
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
              Webpage Group
            </div>
            <Select
              showSearch
              allowClear
              className="common-select"
              placeholder="Select webpage group"
              value={userData.webpage_group || null}
              onSelect={(v) => {
                setUserData({ ...userData, webpage_group: v });
              }}
              onClear={() => {
                setUserData({ ...userData, webpage_group: "" });
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {webpageGroups.map((x, index) => {
                return (
                  <Option value={x.id} key={index}>
                    {x.title || `Group ${x.id}`}
                  </Option>
                );
              })}
            </Select>
          </Col>
          <Col xs={24} sm={12}>
            <Row gutter={20}>
              <Col sm={8}>
                <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                  Credit Card Fee
                </div>
                <Input
                  value={userData.credit_fee}
                  type={"number"}
                  step={0.01}
                  suffix="%"
                  className={
                    errorField !== undefined &&
                      errorField.includes("credit_fee")
                      ? `common-input-error`
                      : `common-input`
                  }
                  onChange={(e) => {
                    if (errorField.includes("credit_fee")) {
                      let errors = errorField.filter(
                        (y) => y != "credit_fee"
                      );
                      setErrorField([...errors]);
                    }
                    setUserData({ ...userData, credit_fee: e.target.value });
                  }}
                />
              </Col>
              <Col sm={8}>
                <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                  Debit Card Fee
                </div>
                <Input
                  value={userData.debit_fee}
                  type={"number"}
                  step={0.01}
                  suffix="%"
                  className={
                    errorField !== undefined &&
                      errorField.includes("debit_fee")
                      ? `common-input-error`
                      : `common-input`
                  }
                  onChange={(e) => {
                    if (errorField.includes("debit_fee")) {
                      let errors = errorField.filter(
                        (y) => y != "debit_fee"
                      );
                      setErrorField([...errors]);
                    }
                    setUserData({ ...userData, debit_fee: e.target.value });
                  }}
                />
              </Col>
              <Col sm={8}>
                <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                  eCheck Fee
                </div>
                <Input
                  value={userData.echeck_fee}
                  type={"number"}
                  prefix="$"
                  suffix="USD"
                  step={0.01}
                  className={
                    errorField !== undefined &&
                      errorField.includes("echeck_fee")
                      ? `common-input-error`
                      : `common-input`
                  }
                  onChange={(e) => {
                    if (errorField.includes("echeck_fee")) {
                      let errors = errorField.filter(
                        (y) => y != "echeck_fee"
                      );
                      setErrorField([...errors]);
                    }
                    setUserData({ ...userData, echeck_fee: e.target.value });
                  }}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={12}>
            <Row align={"middle"} gutter={16}>
              <Col>
                <div style={{ fontWeight: 600 }}>Information Page</div>
              </Col>
              <Col>
                <div className="info_uploader">
                  <label htmlFor="info_uploader">
                    <input
                      type="file"
                      id="info_uploader"
                      name="info_uploader"
                      style={{ display: "none" }}
                      accept="application/pdf"
                      onChange={(e) => {
                        const files = Array.from(e.target.files);
                        if (files.length === 0) return;
                        if (!files[0].name.toLowerCase().endsWith(".pdf")) {
                          message.error("Please upload a PDF file");
                          e.target.value = "";
                          return;
                        }
                        setInfoUrl(files[0].name);
                        setSelInfoFile(files[0]);
                      }}
                    />
                    <span className="custom-button common-button">Browse</span>
                  </label>
                </div>
              </Col>
            </Row>
            {infoUrl === "" && currentInfoUrl !== "" && (
              <div style={{ marginTop: 10 }}>{currentInfoUrl}</div>
            )}
            {infoUrl !== "" && <div style={{ marginTop: 10 }}>{infoUrl}</div>}
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ paddingTop: "10px" }}>
              <Checkbox
                checked={userData.no_registration_required}
                onChange={(e) => {
                  setUserData({ ...userData, no_registration_required: e.target.checked });
                }}
              >
                <span style={{ fontWeight: 600 }}>No Registration Required</span>
              </Checkbox>
              <div style={{ fontSize: "12px", color: "#888", marginTop: "5px", marginLeft: "24px" }}>
                Check this if this is an informational item that doesn't require registration
              </div>
            </div>
            <div style={{ paddingTop: "10px" }}>
              <Checkbox
                checked={userData.allow_multiple_participants}
                onChange={(e) => {
                  setUserData({ ...userData, allow_multiple_participants: e.target.checked });
                }}
              >
                <span style={{ fontWeight: 600 }}>Allow Multiple Participants</span>
              </Checkbox>
              <div style={{ fontSize: "12px", color: "#888", marginTop: "5px", marginLeft: "24px" }}>
                Allow users to add more than one participant per registration
              </div>
            </div>
            <div style={{ paddingTop: "10px" }}>
              <Checkbox
                checked={userData.allow_multi_select_registrations}
                onChange={(e) => {
                  setUserData({ ...userData, allow_multi_select_registrations: e.target.checked });
                }}
              >
                <span style={{ fontWeight: 600 }}>Allow Multi-Select Registrations</span>
              </Checkbox>
              <div style={{ fontSize: "12px", color: "#888", marginTop: "5px", marginLeft: "24px" }}>
                Allow users to choose more than one main registration
              </div>
            </div>
          </Col>
        </Row>
        <div style={{ marginTop: 60, textAlign: "center" }}>
          <CommonButton
            style={{ padding: "12px 45px" }}
            onClick={() => {
              onSave();
            }}
          >
            Save
          </CommonButton>
        </div>
      </Spin>
    </div>
  );
};
export default GeneralTab;
